import { Button, Grid, Typography } from "@mui/material"
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const InstallmentPaymentCart = ({ onClick }: { onClick: Function }) => {
    return (
        <Grid container flexDirection={"column"} gap={"1.5rem"} sx={{ padding: "8px 20px", border: "1px solid var(--border-color)", minHeight: "110px", background: "var(--input-bg-color)", borderRadius: "5px" }}>
            <Grid item sx={{ height: "70%" }}>
                <Grid container>
                    <Grid item xs={1}>
                        <img src="/images/flower.png" alt="flower in the hand" />
                    </Grid>
                    <Grid item xs={11}>
                        <Typography sx={{ color: "var(--primary-text-color)", fontWeight: "bold", fontSize: "0.875rem" }}>
                            دوست عزیز
                        </Typography>
                        <Typography sx={{ color: "var(--primary-text-color)", fontWeight: "bold", fontSize: "0.875rem" }}>
                            در صورت تمایل می توانید اقساط خود را پیش از موعد پرداخت نمائید.
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{ height: "30%" }}>
                <Button onClick={() => onClick()} sx={{ background: "#F99600", color: "#fff", '&:hover': { background: "#F99600" } }} fullWidth>
                    <AutoAwesomeIcon sx={{ fontSize: "24px", marginLeft: "5px" }} />
                    <span style={{ fontWeight: "bold" }}>
                        پرداخت اقساط
                    </span>
                </Button>
            </Grid>
        </Grid>
    )
}

export default InstallmentPaymentCart